"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtons = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Localization = require("../Localization");
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _jsxRuntime = require("react/jsx-runtime");
const StyledGrid = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  paddingBlockStart: theme.spacing(1),
  order: 99
}));
const StyledGridItem = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  width: '320px',
  [theme.breakpoints.up('sm')]: {
    width: '330px'
  }
}));
const ActionButtons = props => {
  const {
    isValid,
    isSubmitting,
    handleCancel,
    isDisabled,
    canRead,
    alwaysShowCancel
  } = props;
  const allowSaveButton = isValid;
  const saveButtonColor = allowSaveButton ? 'primary' : 'inherit';
  const saveButtonDisabled = (allowSaveButton ? isSubmitting : true) || isDisabled;
  const onlyRead = isDisabled && canRead;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledGrid, {
    container: true,
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    children: [onlyRead ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledGridItem, {
      size: {
        xs: 12
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        type: "submit",
        color: saveButtonColor,
        variant: "contained",
        disabled: saveButtonDisabled,
        "data-testid": getTestId('address-save-button'),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations.defaultTranslations.save,
          id: _TranslationKey.TranslationKey.save
        })
      })
    }), alwaysShowCancel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledGridItem, {
      size: {
        xs: 12
      },
      mt: 3,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "text",
        "data-testid": getTestId('address-cancel-button'),
        onClick: handleCancel,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations.defaultTranslations.cancel,
          id: _TranslationKey.TranslationKey.cancel
        })
      })
    }) : null]
  });
};
exports.ActionButtons = ActionButtons;
//# sourceMappingURL=ActionButtons.js.map